import { SxStyles } from 'types';

export const root: SxStyles = {
  paddingInline: '20px',
};
